import {type FC} from 'react'
import cn from 'clsx'
import {IconChevronRightThick} from '~/icons/brg-icon-chevron-right-thick'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'

type MetricCardProps = {
  metric: {
    id: string
    title: string
    percent: number
    description: string
  }
  isOpen: boolean
  onToggle: () => void
  cardIndex: number
}

const MetricCard: FC<MetricCardProps> = ({metric, isOpen, onToggle, cardIndex}) => {
  const reportWidgetClicked = useReportWidgetClick()
  const [cardRef] = useReportWidgetSeen({
    widget_name: 'improved-home-metrics-card',
    widget_place: `${cardIndex + 1}`,
  })

  const handleCardClick = () => {
    onToggle()
    reportWidgetClicked({
      widget_name: 'improved-home-metrics-card',
      widget_place: `${cardIndex + 1}`,
      trigger_type: !isOpen ? 'open' : 'close',
      variation: metric.title,
    })
  }

  return (
    <div ref={cardRef} className="h-fit w-full overflow-hidden rounded-md bg-[#121212] text-white">
      <button
        type="button"
        className="flex w-full flex-col items-center justify-between gap-x-3 px-5 py-4 text-left desktop:gap-y-5 tablet:flex-row tablet:px-3 tablet:py-5"
        onClick={handleCardClick}
        aria-expanded={isOpen}
      >
        <div className="flex w-full flex-row items-center gap-x-2 desktop:justify-between">
          <span className="min-w-fit text-[22px] font-bold leading-none">{metric.percent}%</span>

          <span className="truncate text-sm font-medium text-[#E7E7E7] tablet:mx-auto">{metric.title}</span>
        </div>

        <div className="flex flex-row items-center justify-between gap-x-5 desktop:w-full tablet:gap-x-2">
          <div className="h-1 w-full rounded-full bg-[#5A5A5A] tablet:w-64 mobile:w-24">
            <div className="h-full rounded-full bg-[#61C200]" style={{width: `${metric.percent}%`}} />
          </div>
          <IconChevronRightThick
            fill="white"
            className={cn('size-3 transition-transform duration-300 ease-in-out', isOpen ? '-rotate-90' : 'rotate-90')}
          />
        </div>
      </button>

      <div
        className={cn(
          'grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className="min-h-0">
          <div
            className={cn(
              'text-sm font-light leading-[1.4] text-[#C7C7C7] transition-all duration-300 ease-in-out',
              isOpen
                ? 'border-t border-[#2A2A2A] px-5 py-4 opacity-100 tablet:px-4'
                : 'px-5 py-0 opacity-0 tablet:px-4',
            )}
          >
            {metric.description}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MetricCard
